export default {
  height:'auto',
  calcHeight: 30,
  tip: false,
  searchShow: true,
  searchMenuSpan: 6,
  border: true,
  index: true,
  viewBtn: true,
  selection: true,
  dialogClickModal: false,
  column: [
    {
      label: "",
      prop: "id",
      type: "input",
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      hide: true,
    },
    {
      label: "全平台用户id",
      prop: "unionId",
      type: "input",
    },
    {
      label: "来源类型",
      prop: "sourceType",
      type: "select",
      dicUrl: "/api/blade-system/dict/dictionary?code=user_source",
      dataType: "number",
      props: {
        label: "dictValue",
        value: "dictKey"
      },
      search: true,
    },
    {
      label: "微信登录关联",
      prop: "wechatOpenId",
      type: "input",
    },
    {
      label: "手机号",
      prop: "phone",
      type: "input",
      search: true,
      rules: [{
        required: true,
        message: "请输入手机号",
        trigger: "blur"
      }],
    },
    {
      label: "昵称",
      prop: "nickName",
      type: "input",
    },
    {
      label: "头像",
      prop: "avatar",
      type: "input",
    },
    {
      label: "真实姓名",
      prop: "realName",
      type: "input",
    },
    {
      label: "身份证号码",
      prop: "idCard",
      type: "input",
    },
    {
      label: "密码",
      prop: "password",
      type: "input",
    },
    {
      label: "注册日期",
      prop: "registerTime",
      type: "input",
    },
    {
      label: "认证标志",
      prop: "authFlag",
      type: "input",
    },
    {
      label: "租户ID",
      prop: "tenantId",
      type: "input",
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      hide: true,
    },
    {
      label: "创建人",
      prop: "createUser",
      type: "input",
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      hide: true,
    },
    {
      label: "创建部门",
      prop: "createDept",
      type: "input",
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      hide: true,
    },
    {
      label: "创建时间",
      prop: "createTime",
      type: "input",
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      hide: true,
    },
    {
      label: "修改人",
      prop: "updateUser",
      type: "input",
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      hide: true,
    },
    {
      label: "修改时间",
      prop: "updateTime",
      type: "input",
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      hide: true,
    },
    {
      label: "状态",
      prop: "status",
      type: "input",
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      hide: true,
    },
    {
      label: "是否已删除",
      prop: "isDeleted",
      type: "input",
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      hide: true,
    },
  ]
}
